import { render, staticRenderFns } from "./SetPasswordDialog.vue?vue&type=template&id=ed9132da&scoped=true"
import script from "./SetPasswordDialog.vue?vue&type=script&lang=js"
export * from "./SetPasswordDialog.vue?vue&type=script&lang=js"
import style0 from "./SetPasswordDialog.vue?vue&type=style&index=0&id=ed9132da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9132da",
  null
  
)

export default component.exports